import React from 'react';
import TableColumnTitle from '../../../../../../components/_table/TableColumnTitle';
import OpenOrderItemDetail from '../../../../../../components/link/OpenOrderItemDetail';
import OpenPreviewProductDetail from '../../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenOrderDeliveryTracking from '../../../../../../containers/app/common/OpenOrderDeliveryTracking';
import OpenProductDetail from '../../../../../../components/link/OpenProductDetail';
import Anchor from '../../../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';
import {
  ORDER_ACCEPT_MANAGER_TEXT,
  ORDER_DELIVERY_TYPE_TEXT,
  ORDER_EXCHANGE_STATUS_TEXT,
  ORDER_EXCHANGE_TYPE_TEXT,
  ORDER_GIFT_STATUS_SELECT_LIST,
  ORDER_GIFT_STATUS_TEXT,
  ORDER_TYPE_SELECT_LIST,
  ORDER_TYPE_TEXT,
  ORDER_ITEM_STATUS_TEXT,
  PAY_METHOD_TYPE_TEXT,
  RETURN_EXCHANGE_REASON_TYPE,
  TAKEBACK_METHOD_TEXT,
} from '../../../../../../constants/service/app/orderConstants';
import { BRAND_TYPE_TEXT } from '../../../../../../constants/service/app/brandConstants';
import { PRODUCT_MANAGEMENT_TYPE_TEXT } from '../../../../../../constants/service/app/productConstants';
import {
  addAllItemToSelectList,
  asyncSimpleModal,
  setDash,
  setPhoneFormat,
  setNumberWithComma,
} from '../../../../../../lib/common';
import { setBuyerAccount } from '../../../../../../lib/utils/orderutils';
import { setDateFormat } from '../../../../../../lib/moment';
import TableFilterSelect from '../../../../../../components/_table/TableFilterSelect';
import OpenBrandDetail from '../../../../../../components/link/OpenBrandDetail';

const columns = (data) => {
  const { getOrderExchangeAttachment, filterOption, onFilter } = data;

  return [
    {
      title: <TableColumnTitle title="주문 타입" filterValue={ORDER_TYPE_TEXT[filterOption.orderType]} />,
      dataIndex: 'orderType',
      filterDropdown: ({ confirm }) => (
        <TableFilterSelect
          list={addAllItemToSelectList(ORDER_TYPE_SELECT_LIST)}
          option={filterOption.orderType}
          confirm={confirm}
          onFilter={(orderType) => onFilter({ orderType })}
        />
      ),
      render: (value) => setDash(ORDER_TYPE_TEXT[value]),
    },
    {
      title: <TableColumnTitle title="선물 상태" filterValue={ORDER_GIFT_STATUS_TEXT[filterOption.giftStatus]} />,
      dataIndex: 'giftStatus',
      filterDropdown: ({ confirm }) => (
        <TableFilterSelect
          list={addAllItemToSelectList(ORDER_GIFT_STATUS_SELECT_LIST)}
          option={filterOption.giftStatus}
          confirm={confirm}
          onFilter={(giftStatus) => onFilter({ giftStatus })}
        />
      ),
      render: (value) => setDash(ORDER_GIFT_STATUS_TEXT[value]),
    },
    {
      title: <TableColumnTitle title={['교환 정보']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['주문번호']} />,
          dataIndex: 'orderId',
        },
        {
          title: <TableColumnTitle title={['상품 주문번호']} />,
          dataIndex: 'orderItemId',
          render: (value) => <OpenOrderItemDetail text={value} orderItemId={value} />,
        },
        {
          title: <TableColumnTitle title={['주문 메시지']} />,
          dataIndex: 'orderMessage',
          render: (value) =>
            value ? (
              <Anchor
                color="primary"
                isUnderLine={true}
                text="확인하기"
                onClick={async () =>
                  await asyncSimpleModal({
                    type: 'info',
                    title: '주문 메시지',
                    message: value,
                  })
                }
              />
            ) : (
              '-'
            ),
        },
        {
          title: '스타일코드(바코드)',
          dataIndex: 'productStyleCode',
          render: (value) => setDash(value),
        },
        {
          title: '바코드',
          dataIndex: 'productOptionStyleCode',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle title={['주문 상태']} />,
          dataIndex: 'orderItemStatus',
          render: (value) => ORDER_ITEM_STATUS_TEXT[value],
        },
        {
          title: <TableColumnTitle title={['교환 처리 상태']} />,
          dataIndex: 'orderItemExchangeStatus',
          render: (value) => ORDER_EXCHANGE_STATUS_TEXT[value],
        },
        {
          title: <TableColumnTitle title={['접수자']} />,
          dataIndex: 'acceptManager',
          render: (value) => ORDER_ACCEPT_MANAGER_TEXT[value],
        },
        {
          title: <TableColumnTitle title={['회수 방식']} />,
          dataIndex: 'isAutoTakeback',
          render: (value) => TAKEBACK_METHOD_TEXT[value],
        },
        {
          title: <TableColumnTitle title={['택배사']} />,
          dataIndex: 'takebackDeliveryEnterpriseName',
          render: (value) => value ?? '-',
        },
        {
          title: <TableColumnTitle title={['회수 송장번호']} />,
          dataIndex: 'takebackInvoiceNumber',
          render: (value) => value ?? '-',
        },
        {
          title: <TableColumnTitle title={['교환 사유 수정 일시']} />,
          dataIndex: 'exchangeReasonModifyDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['교환사유']} />,
          dataIndex: 'exchangeType',
          render: (value, record) => (
            <Anchor
              color="primary"
              text={ORDER_EXCHANGE_TYPE_TEXT[value]}
              isUnderLine={true}
              onClick={() =>
                getOrderExchangeAttachment({
                  orderExchangeId: record.orderExchangeId,
                  reasonType: RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REQUEST,
                  buyerName: record.buyerName,
                  buyerAccount: record.buyerAccount,
                  date: record.exchangeRequestDate,
                  orderItemId: record.orderItemId,
                  buyerPhone: record.buyerPhone,
                  productName: record.productName,
                  reason: record.exchangeReason,
                })
              }
            />
          ),
        },
        {
          title: <TableColumnTitle title={['교환 배송 방법']} />,
          dataIndex: 'exchangeDeliveryType',
          render: (value) => setDash(ORDER_DELIVERY_TYPE_TEXT[value]),
        },
        {
          title: <TableColumnTitle title={['교환 배송 택배사']} />,
          dataIndex: 'exchangeDeliveryAgentName',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle title={['교환 배송 송장번호']} />,
          dataIndex: 'exchangeInvoiceNumber',
          render: (value) => setDash(value),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['교환 거부']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['교환 거부사유']} />,
          dataIndex: 'rejectReason',
          render: (value, record) =>
            value ? (
              <Anchor
                color="primary"
                text="내용 보기"
                isUnderLine={true}
                onClick={() =>
                  getOrderExchangeAttachment({
                    orderExchangeId: record.orderExchangeId,
                    reasonType: RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REJECT,
                    buyerName: record.buyerName,
                    buyerAccount: record.buyerAccount,
                    date: record.rejectDate,
                    orderItemId: record.orderItemId,
                    buyerPhone: record.buyerPhone,
                    productName: record.productName,
                    reason: value,
                  })
                }
              />
            ) : (
              '-'
            ),
        },
        {
          title: <TableColumnTitle title={['교환 거부 일시']} />,
          dataIndex: 'rejectDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['교환 배송 상태']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['주문 일시']} />,
          dataIndex: 'orderDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['결제 일시']} />,
          dataIndex: 'paymentDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['교환 요청 일시']} />,
          dataIndex: 'exchangeRequestDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['수거 완료 일시']} />,
          dataIndex: 'receiveDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['교환품 배송 처리 일시']} />,
          dataIndex: 'exchangeDispatchDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
        {
          title: <TableColumnTitle title={['배송추적']} />,
          dataIndex: 'deliveryTracking',
          render: (value, record) => (
            <OpenOrderDeliveryTracking
              deliveryId={record.exchangeDeliveryId}
              targetStatus={record.orderItemExchangeStatus}
              deliveryType={record.exchangeDeliveryType}
            />
          ),
        },
        {
          title: <TableColumnTitle title={['교환 완료 일시']} />,
          dataIndex: 'exchangeCompleteDate',
          render: (value) => setDateFormat(value, DATE_FORMAT.YMD_HM_DOT_FORMAT),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['구매자/수취인']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['구매자ID']} />,
          dataIndex: 'buyerAccount',
          render: (value) => setBuyerAccount(value),
        },
        {
          title: <TableColumnTitle title={['구매자명']} />,
          dataIndex: 'buyerName',
        },
        {
          title: <TableColumnTitle title={['수취인명']} />,
          dataIndex: 'recipientName',
        },
      ],
    },
    {
      title: <TableColumnTitle title={['구매상품 정보']} color="primary" />,
      children: [
        {
          title: '브랜드명',
          dataIndex: 'brandName',
          render: (value, record) => <OpenBrandDetail text={value} storeId={record.storeId} />,
        },
        {
          title: '브랜드 ID',
          dataIndex: 'storeId',
          render: (value) => <OpenBrandDetail text={value} storeId={value} />,
        },
        {
          title: <TableColumnTitle title={['상품번호']} />,
          dataIndex: 'productId',
          render: (value) => <OpenProductDetail text={value} productId={value} />,
        },
        {
          title: <TableColumnTitle title={['제품번호']} />,
          dataIndex: 'productNumber',
          render: (value) => setDash(value),
        },
        {
          title: '관리처',
          dataIndex: 'store',
          render: (value) => setDash(BRAND_TYPE_TEXT[value]),
        },
        {
          title: '타입',
          dataIndex: 'productType',
          render: (value) => setDash(PRODUCT_MANAGEMENT_TYPE_TEXT[value]),
        },
        {
          title: <TableColumnTitle title={['상품명']} />,
          dataIndex: 'productName',
          render: (value, record) => <OpenPreviewProductDetail text={value} productId={record.productId} />,
        },
        {
          title: '1차 카테고리',
          dataIndex: 'mainCategory',
        },
        {
          title: <TableColumnTitle title={['옵션정보']} />,
          dataIndex: 'productOption',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle title={['옵션 제품번호']} />,
          dataIndex: 'productOptionNumber',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle title={['수량']} />,
          dataIndex: 'quantity',
          render: (value) => setNumberWithComma(value),
        },
        {
          title: <TableColumnTitle title={['상품 가격(정가)']} />,
          dataIndex: 'productPrice',
          render: (value) => setNumberWithComma(value),
        },
        {
          title: <TableColumnTitle title={['상품 할인액(차감된 금액)']} />,
          dataIndex: 'discountPrice',
          render: (value) => setNumberWithComma(value),
        },
        {
          title: <TableColumnTitle title={['옵션가격']} />,
          dataIndex: 'productOptionPrice',
          render: (value) => setNumberWithComma(value),
        },
        {
          title: <TableColumnTitle title={['쿠폰']} />,
          dataIndex: 'usedCoupon',
          render: (value) => setNumberWithComma(value),
        },
        {
          title: <TableColumnTitle title={['Apoint']} />,
          dataIndex: 'usedPoint',
          render: (value) => setNumberWithComma(value),
        },
        {
          title: <TableColumnTitle title={['상품 별 총 주문금액']} />,
          dataIndex: 'totalPrice',
          render: (value) => setNumberWithComma(value),
        },
        {
          title: <TableColumnTitle title={['추가 배송비']} />,
          dataIndex: 'deliveryExtraFee',
          render: (value) => setNumberWithComma(value),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['(기존)배송 수취 정보']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['구매자 연락처']} />,
          dataIndex: 'buyerPhone',
          render: (value) => setPhoneFormat(value),
        },
        {
          title: <TableColumnTitle title={['수취인 연락처']} />,
          dataIndex: 'recipientPhone',
          render: (value) => setPhoneFormat(value),
        },
        {
          title: <TableColumnTitle title={['배송지']} />,
          dataIndex: 'shippingAddress',
          render: (value, record) => `${record.shippingAddress1} ${record.shippingAddress2}`,
        },
        {
          title: <TableColumnTitle title={['우편번호']} />,
          dataIndex: 'shippingPostCode',
        },
        {
          title: <TableColumnTitle title={['배송메시지']} />,
          dataIndex: 'shippingMessage',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle className="delivery-type" title={['배송방법']} />,
          dataIndex: 'deliveryType',
          render: (value) => setDash(ORDER_DELIVERY_TYPE_TEXT[value]),
        },
        {
          title: <TableColumnTitle className="delivery-agent" title={['택배사']} />,
          dataIndex: 'deliveryAgentName',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle className="invoice-number" title={['송장정보']} />,
          dataIndex: 'invoiceNumber',
          render: (value) => setDash(value),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['(신규)배송 수취 정보']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['구매자 연락처']} />,
          dataIndex: 'exchangeBuyerPhone',
          render: (value) => setDash(setPhoneFormat(value)),
        },
        {
          title: <TableColumnTitle title={['수취인 연락처']} />,
          dataIndex: 'exchangeRecipientPhone',
          render: (value) => setDash(setPhoneFormat(value)),
        },
        {
          title: <TableColumnTitle title={['배송지']} />,
          dataIndex: 'exchangeShippingAddress',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle title={['우편번호']} />,
          dataIndex: 'exchangeShippingPostCode',
          render: (value) => setDash(value),
        },
        {
          title: <TableColumnTitle title={['배송메시지']} />,
          dataIndex: 'exchangeShippingMessage',
          render: (value) => setDash(value),
        },
      ],
    },
    {
      title: <TableColumnTitle title={['결제 정보']} color="primary" />,
      children: [
        {
          title: <TableColumnTitle title={['결제 수단']} />,
          dataIndex: 'payMethod',
          render: (value) => PAY_METHOD_TYPE_TEXT[value],
        },
      ],
    },
  ];
};

export default columns;
